import { FormFilePickField } from '@/components/common/FormDialog';
import {
  DONATION_FILE_ACCEPT,
  DONATION_IMAGE_LABELS,
} from '../constants/marketPromotion.constants';

export function DonationImageFields() {
  return (
    <div className="grid gap-4 sm:grid-cols-3">
      {DONATION_IMAGE_LABELS.map((label) => (
        <FormFilePickField key={label} label={label} accept={DONATION_FILE_ACCEPT} />
      ))}
    </div>
  );
}
